import React from 'react';
import { FileTypeIcon } from '@/components/Icons/FileTypeIcon';
import type { Attachment } from '@/types/attachment';
import { openAttachment } from '@/utils/attachments';
import { formatFileSize, getFileExtension, getFileType } from '@/utils/file';

interface Props {
  attachment: Attachment;
  onPreview: (attachment: Attachment) => void;
  onDownloaded?: () => void;
}

export const AttachmentCard: React.FC<Props> = ({
  attachment,
  onPreview,
  onDownloaded,
}) => {
  const fileType = getFileType(attachment.name);
  const extension = getFileExtension(attachment.name);

  return (
    <button
      type="button"
      onClick={() => openAttachment({ attachment, onPreview, onDownloaded })}
      className="flex w-[76px] shrink-0 cursor-pointer flex-col items-start gap-2 text-left"
    >
      <FileTypeIcon type={fileType} className="size-[76px]" />
      <div className="flex w-full min-w-0 flex-col gap-0.5">
        <p className="w-full truncate text-caption-13 text-foreground">
          {attachment.name}
        </p>
        <p className="w-full truncate text-caption-12 text-subtle-foreground">
          {extension.toUpperCase()} {formatFileSize(attachment.sizeInBytes)}
        </p>
      </div>
    </button>
  );
};
